import { render } from "./OptionSection.vue?vue&type=template&id=e051c39a&scoped=true"
import script from "./OptionSection.vue?vue&type=script&lang=js"
export * from "./OptionSection.vue?vue&type=script&lang=js"

import "./OptionSection.vue?vue&type=style&index=0&id=e051c39a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e051c39a"]])

export default __exports__